import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  CmsConfig,
  I18nModule,
  provideConfig,
  UrlModule,
  UserConsentAdapter
} from '@spartacus/core'
import { PageSlotModule } from '@spartacus/storefront'
import { EbSpinnerModule } from '../../components/spinner/eb-spinner.module'
import { EbAuthGuard } from '../auth/guards/eb-auth.guard'
import { EbConsentManagementComponent } from './consent-management/components/consent-management/eb-consent-management.component'
import { EbConsentManagementFormComponent } from './consent-management/components/consent-management-form/eb-consent-management-form.component'
import { EbUserConsentAdapter } from './consent-management/services/eb-user-consent.adapter'
import { ebMyAccountLayoutConfig } from './eb-my-account-layout.config'

@NgModule({
  imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, EbSpinnerModule],
  providers: [
    provideConfig({
      cmsComponents: {
        ConsentManagementComponent: {
          component: EbConsentManagementComponent,
          guards: [EbAuthGuard]
        }
      }
    } as CmsConfig),
    provideConfig(ebMyAccountLayoutConfig),
    {
      provide: UserConsentAdapter,
      useClass: EbUserConsentAdapter
    }
  ],
  declarations: [EbConsentManagementComponent, EbConsentManagementFormComponent],
  exports: [EbConsentManagementComponent, EbConsentManagementFormComponent]
})
export class EbMyAccountModule {}
